import { SidebarCalloutProps } from '@/components/_blog-updates/SidebarCallout';
import { CraftSidebarCalloutData } from './CraftSidebarCallout.types';

export const mapBlockToSidebarCalloutProps = (block: CraftSidebarCalloutData): SidebarCalloutProps => {
  const rawContent =
    typeof block.calloutContent === 'string' ? block.calloutContent : JSON.stringify(block.calloutContent);

  return {
    contentData: {
      rawNodes: rawContent,
      nodes: [],
    },
  };
};
